import styled from 'styled-components';
import { palette } from '../styles';

export const MainStyled = styled.main`
  width: 100%;
  padding: 0;
  margin: 0;
  font-family: 'Sofia Pro', sans-serif;
  @media screen and (max-width: 1337px) {
    margin-left: 2% !important;
    width: 98% !important;
  }
  .graphicsSide {
    display: flex;
    flex-direction: column;
    margin: 0px 50px;
    p {
      font-size: 20px;
      font-weight: 500;
      line-height: 32px;
      color: ${palette.black};
      padding: 0;
      margin: 52px 0px 22px;
      text-align: start;
    }
  }
  .special-open {
    position: absolute;
    top: 15%;
    right: -32px;
    transform: translateY(-50%);
    background-color: #f69953;
    width: 64px;
    height: 64px;
    border-radius: 64px;
    border: none;
    transition: ease-in-out 0.2s;
    &:hover {
      cursor: pointer;
    }
    svg {
    }
  }
  .welcomePage {
    width: 100%;
    display: flex;
    padding: 64px 32px 172px 32px;
    justify-content: space-between;
    align-items: center;
    background-color: ${(props) => (props.adminColor ? props.adminColor : '#0f3f44')};
    border-radius: 4px;
    margin: 12px 0 32px 0;
    position: relative;
  }
  .welcomeTextContainer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    h1 {
      font-family: 'Cooper Md BT', serif;
      color: #fff;
      font-size: 48px;
    }
    .golden {
      color: #f2cdbd;
      font-family: inherit;
      font-size: inherit;
    }
    p {
      font-size: 20px !important;
      color: ${palette.white};
      font-weight: 500;
      line-height: 32px;
      padding: 0;
      margin: 12px 0;
      text-align: start;
    }
    ul {
      color: #fff;
      padding-left: 12px;
      li {
        margin-bottom: 12px;
      }
    }
  }
  .welcomeImageContainer {
    width: 30%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    img {
      width: 160px;
      height: auto;
      position: absolute;
      margin-top: -24px;
      @media screen and (max-width: 1366px) {
        margin-top: -50px;
      }
    }
  }
  h1 {
    font-family: 'Cooper Md BT', serif;
    font-size: 28px;
    color: ${(props) => (props.adminColor ? props.adminColor : '#0f3f44')};
  }
  .analitycsCard {
    width: 100%;
    display: flex;
    margin-bottom: 50px;
    justify-content: space-between;
    align-items: center;
    background-color: ${palette.white};
    flex-direction: column;
    font-family: 'Sofia Pro', sans-serif;
    border-radius: 8px;
  }
  .tablesSide {
    width: 375px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0;
    top: 0;
    background-color: ${palette.white};
    position: fixed;
    height: 100vh;
    overflow: auto;
    right: 0;
  }
  .tablesNav {
    width: 100%;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
  .tableContainer {
    width: 100%;
  }
  .tableNavItemActive {
    font-size: 1.6rem !important;
    border-bottom: 4px solid #5373fc;
    font-weight: 500;
    line-height: 32px;
    text-align: center;
    margin: 0px;
  }
  .tableNavItem {
    font-size: 1.6rem !important;
    text-align: center;
    font-weight: 500;
    line-height: 32px;
    cursor: pointer;
    margin: 0px;
  }
  .tableOptions {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    background-color: ${(props) => (props.adminColor ? props.adminColor : '#0f3f44')};
    padding: 12px;
  }
  .acceptAll {
    width: 35%;
    font-weight: 600;
    font-size: 1.2rem;
    color: ${palette.accept};
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 0;
    cursor: pointer;
  }
  .denyAll {
    width: 35%;
    font-weight: 600;
    font-size: 1.2rem;
    color: ${palette.red};
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: auto;
    margin-bottom: 0;
    cursor: pointer;
  }
  .toggleOptions {
    width: 20%;
    display: contents;
    p {
      margin-right: 8px;
      color: #fff;
      justify-self: center;
      align-self: center;
    }
    button {
      background-color: #f69953;
      border: none;
      border-radius: 64px;
      width: 42px;
      height: 42px;
      position: relative;
      svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  .tableContent {
    position: absolute;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    width: 100%;
  }
  .notfound {
    width: 128px;
    margin: 32px auto 0 auto;
    display: table;
  }
  .validationMessage {
    width: 45%;
    margin: 32px auto;
    text-align: center;
    font-size: 18px;
  }
  .backdrop {
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .card {
    margin: 12px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 8px 10px;
    border-radius: 4px;
    background-color: #f4f4f4;
    p {
      color: #0f3f44;
    }
  }
  .userInfo {
    width: calc(65% - 50px);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .userName {
    font-size: 18px;
    padding: 0;
    margin-bottom: 8px;
    font-weight: 400;
    font-family: 'Cooper Md BT', serif;
  }
  .userData {
    font-size: 1rem;
    padding: 0;
    margin: 0;
  }
  .userActions {
    width: 20%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .hiddencard {
    display: none;
  }
  .MuiTabs-root {
    background-color: ${(props) => (props.adminColor ? props.adminColor : '#0f3f44')};
  }
  .MuiTab-root {
    padding: 24px;
  }
  .MuiTab-wrapper {
    color: #fff;
    font-family: 'Cooper Md BT', serif;
    font-size: 16px;
    font-weight: 700;
  }
  .PrivateTabIndicator-colorSecondary-3,
  .PrivateTabIndicator-colorSecondary-7 {
    background-color: #fcd7e0;
  }
  .MuiDrawer-paperAnchorDockedRight {
    border-left: none;
    max-height: 98vh;
    margin: 12px 0;
    border-top-left-radius: 24px;
    border-bottom-right-radius: 24px;
    box-shadow: 0 0px 2.8px -24px rgba(0, 0, 0, 0.02), 0 0px 6.7px -24px rgba(0, 0, 0, 0.028),
      0 0px 12.5px -24px rgba(0, 0, 0, 0.035), 0 0px 22.3px -24px rgba(0, 0, 0, 0.042),
      0 0px 41.8px -24px rgba(0, 0, 0, 0.05), 0 0px 100px -24px rgba(0, 0, 0, 0.07);
  }
  .k-avatar-solid.k-avatar-primary {
    border-color: ${(props) => (props.adminColor ? props.adminColor : '#0f3f44')};
    background-color: ${(props) => (props.adminColor ? props.adminColor : '#0f3f44')};
  }
`;
export default null;
